import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

interface HeroSectionProps {
  onCtaClick: (label: string) => void; // CTAクリックの関数を受け取る
}

export default function HeroSection({ onCtaClick }: HeroSectionProps) {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section
      id="home"
      className="relative min-h-[720px] md:min-h-[800px] flex items-center justify-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="./images/hero-bg_main.jpg"
          alt="ひろカイロ整体院の施術風景"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/50 to-black/50" />
      </div>

      <div ref={ref} className={`relative z-10 w-full px-4 md:px-8 text-center text-white pt-20 scroll-reveal ${isVisible ? 'visible' : ''}`}>
        <p className="text-sm md:text-base font-medium tracking-widest mb-4 opacity-90 scroll-reveal-item delay-1">
          守谷駅徒歩1分 | 自律神経専門 | 開業21年
        </p>
        <h1 className="font-serif text-2xl md:text-4xl lg:text-5xl font-bold leading-relaxed md:leading-relaxed mb-4 max-w-4xl mx-auto scroll-reveal-item delay-2">
          「どこに行っても良くならない」
          <br className="hidden md:block" />
          そのめまい・頭痛・不眠。
          <br />
          自律神経専門の当院にお任せください。
        </h1>
        <p className="text-sm md:text-lg leading-relaxed opacity-90 max-w-2xl mx-auto mb-8 scroll-reveal-item delay-3">
          病院で「異常なし」と言われた方のための、痛くない「セロトニン活性療法」。
          <br className="hidden md:block" />
          開業21年、のべ5万人以上の実績で、あなたの「笑顔」を取り戻します。
        </p>
        <a
          href="https://lin.ee/yWTagrY"
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => {
            onCtaClick('HeroSection_LINE');
          }}
          className="inline-flex items-center gap-2 bg-clinic-line text-white font-bold text-base md:text-lg px-8 py-4 rounded-full hover:opacity-90 transition-opacity whitespace-nowrap scroll-reveal-item delay-4"
        >
          <i className="ri-line-fill text-2xl sm:text-xl" />
          【24時間受付】<br className="sm:hidden" />LINEで無料相談・予約する
        </a>
      </div>
    </section>
  );
}